import Prism from 'prismjs';
import 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace';
import 'prismjs/components/prism-markdown';
import 'prismjs/components/prism-markup-templating';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-sql';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-twig';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-sass';
import 'prismjs/components/prism-scss';

export const initCodeSnippets = () => {
    Prism.highlightAll();

    $('.blog-post__code-copy').on('click', function () {
        const $button = $(this);
        const code = $button.closest('.blog-post__code').find('code')[0];

        if (!code) {
            return;
        }

        navigator.clipboard.writeText(code.innerText).then(() => {
            $button.addClass('is-copied');
            setTimeout(() => {
                $button.removeClass('is-copied');
            }, 2000);
        });
    });
};
